module.exports = __webpack_public_path__ + "static/media/02.54ef00e0.jpg";